<template>
  <div class="bg-white relative">
    <div class="absolute close--container">
      <zt-tooltip
        :text="tooltipContent"
        position="right"
        color="primary"
        outlined
      >
        <zt-button
          @click="setSearchListVisible(!store.searchListVisible)"
          class="close--list"
          :icon="openIcon"
          fab
          outlined
          style="color: #4f41a3 !important"
          data-vs-button="search-list"
        ></zt-button>
      </zt-tooltip>
    </div>
    <SearchLoading v-if="store.isLoading" />
    <SearchInitialState v-else-if="store.initialStatus" />
    <template v-else-if="store.haveResults">
      <div class="info-box" v-if="isMFA">
        <div class="info-box--inner">
          <div class="info-box-content font-normal">
            <span class="ml-3">
              <i class="zt-icon zt-icon-info-cicle-solid text-zt-xl"></i>
            </span>
            {{$t('message.downloadBackup.downloadModal.messageMFA') }}
          </div>
        </div>
      </div>
      <search-table-messages
        :status="messageStatus"
        :message="messageStatusText"
        :shown="messageShown"
      />
      <SearchTableHeader
        :downloadSelected="isDocumentsSelectedEmpty"
        :documentSelected="documentsSelected"
        @download-selected="downloadZip"
        @show-info-mfa="setInfoboxMFA"
        @cancelled-documents="cancelDocuments"
        :loader="loader"
      />
      <div class="search--table">
        <CustomTable
          :content="store.documents"
          :action="openPreview"
          @documents-selected="setDocumentsSelected"
        />
        <zt-modal
          :z-index="1001"
          :show-button-close="true"
          :active="previewPdf"
          @close="previewPdf = false"
          max-width="50vw"
          :title="$t('message.documentSearch.searchTitlePreview')"
        >
          <div style="height: 80vh;">
            <iframe class="w-full h-full" id="blob"></iframe>
          </div>
        </zt-modal>
        <zt-modal
          :z-index="1001"
          max-width="700px"
          :active="previewNotFound"
          @close="previewNotFound = false"
        >
          <template #modal-header>
            <div class="p-6">
              <span class="text-zt-xl font-bold">{{ $t('message.documentSearch.previewNotFound.title') }}</span>
            </div>
          </template>
          <div class="">
            <div class="px-8 py-16">
              <p class="text-zt-lg text-justify">{{ $t('message.documentSearch.previewNotFound.message') }}</p>
            </div>
          </div>
        </zt-modal>
      </div>
      <SearchTableFooter
        @page-change="emptyDocumentSelected"
      />
    </template>
    <SearchEmptyResults v-else />
  </div>
</template>

<script>
import SearchInitialState from './SearchInitialState.vue'
import SearchEmptyResults from './SearchEmptyResults.vue'
import SearchTableHeader from './SearchTableHeader.vue'
import SearchLoading from './SearchLoading.vue'
import CustomTable from './CustomTable.vue'
import SearchTableFooter from './SearchTableFooter.vue'
import {isEmpty} from 'lodash'
import Search from '@/apiClient/Search'
import Users from '@/apiClient/User'
import {mapState} from 'vuex'
import SearchTableMessages from "./SearchTableMessages";

const setPdfUrl = (pdf) => {
  const url = URL.createObjectURL(pdf)
  document.querySelector('#blob').src = url
}

const b64toBlob = (dataURI) => {
  const byteString = atob(dataURI.split(',')[1])
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ab], { type: 'application/pdf' })
}

export default {
  name: 'SearchTable',
  inject: ['store', 'setSearchListVisible'],
  provide() {
    return {
      hideMessage: this.hideMessage,
      emptyDocumentSelected: this.emptyDocumentSelected
    }
  },
  components: {
    SearchInitialState,
    SearchEmptyResults,
    CustomTable,
    SearchTableHeader,
    SearchTableFooter,
    SearchLoading,
    SearchTableMessages
  },
  data() {
    return {
      documentsSelected: [],
      searchConfig: new Search(),
      usersConfig: new Users(),
      previewPdf: false,
      previewNotFound: false,
      loader: false,
      isMFA: false,
      messageStatusText: '',
      messageStatus: 'danger',
      messageShown: false
    }
  },
  computed: {
    ...mapState(['user']),
    openIcon() {
      return this.store.searchListVisible ? 'angle-left' : 'angle-right-solid'
    },
    tooltipContent() {
      return this.store.searchListVisible
        ? this.$t('message.searchComponent.filters.hide')
        : this.$t('message.searchComponent.filters.show')
    },
    isDocumentsSelectedEmpty() {
      return isEmpty(this.documentsSelected)
    },
  },
  methods: {
    setDocumentsSelected(event) {
      this.documentsSelected = event
    },
    setInfoboxMFA(event) {
      this.isMFA = event
    },
    emptyDocumentSelected(){
       this.documentsSelected = []
    },
    async downloadZip() {
      try {
        this.loader = true
        const { data } = await this.searchConfig.DownloadZip(
          this.documentsSelected
        )

        const newBlob = new Blob([data], { type: 'application/octet-stream' })
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }
        const urlFile = window.URL.createObjectURL(newBlob)
        const link = document.createElement('a')
        link.href = urlFile
        link.download = 'Documentos' + Math.random() * 100 + '.zip'
        link.click()

        this.loader = false
        setTimeout(function() {
          window.URL.revokeObjectURL(urlFile)
        }, 100)
      } catch (error) {
        this.loader = false
      }
    },
    async openPreview({ documentId }) {
      try {
        const response = await this.usersConfig.showPdfDownload(
          this.user.aplicacion.id,
          documentId
        )

        this.previewRef = documentId

        const data_pdf_prefix = 'data:application/pdf;base64,'

        const pdfBlob = b64toBlob(data_pdf_prefix + response)

        this.previewPdf = true

        await this.$nextTick()

        setPdfUrl(pdfBlob)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.previewNotFound = true
        }
      }
    },
    cancelDocuments(message) {
      this.messageStatusText = message.status === 'info'
        ? this.$t('message.cancelDocuments.info')
        : this.$t(`message.cancelDocuments.error.${message.code}`)
      this.messageStatus = message.status
      this.messageShown = true
      this.$emit('reload-table', message.code === 'MASSIVE_CANCEL_SUCCESS')
    },
    hideMessage() {
      this.messageShown = false
    }
  },
}
</script>

<style lang="scss" scoped>
.close--list {
  width: 28px !important;
  height: 28px !important;
}

.close--container {
  left: -1em;
  top: 25px;
}

.search--table {
  max-height: calc(100vh - 74px - 70px - 141px);
  overflow-y: auto;
}

.info-box{
  background: #F5F5F5;
  padding-bottom: 1em;
  .info-box--inner{
    background: #e1f5fe;
    color: #007bff;
    padding: 1em 1.5em;
    margin-bottom: 1em;
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  .info-box-content {
    display: flex;
    align-items: center;
  }
  .btn--fma{
    color: #007bff;
    border-color: #007bff;
    background: #e1f5fe;
  }

}
</style>
